module.exports = __webpack_public_path__ + "static/media/opiniao_comprador_3.9ff6ec19.png";